export const ID = 'id';
export const NAME = 'name';
export const NUMERIC_ISO = 'numericIso';
export const COUNTRY_ID = 'countryId';
